exports = module.exports = require("../../../../css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".video-progress-bar{position:relative}.video-progress-bar--vertical{height:100%;width:4px}.video-progress-bar--horizontal{width:100%;height:4px}.video-progress-bar__fill{background-color:#fff;position:absolute;bottom:0;left:0}.video-progress-bar--horizontal .video-progress-bar__fill{height:100%}.video-progress-bar--vertical .video-progress-bar__fill{width:100%}.video-progress-bar__input{position:absolute;top:0;left:0;right:0;bottom:0;width:100%;height:100%;padding:0;margin:0;border:0;cursor:pointer;outline:none;opacity:0}.video-progress-bar--vertical .video-progress-bar__input{-webkit-appearance:slider-vertical}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/react-html5video/src/components/progressbar/progressbar.css
// module id = 1378
// module chunks = 0